module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-adults-af1cabd93f7f80b9dd2e7a5d15aa2957.svg";